import { Helmet } from 'react-helmet-async';
import { useNavigate, Link } from 'react-router-dom';

import SingleCardTemplate from '@/components/layouts/SingleCardTemplate';
import BackToPageButton from '@/components/ui/buttons/BackToPageButton';
import { pageTitles } from '@/constants/pageTitles';
import Contact from '@/features/contact/components/Contact';
import useCurrentUser from '@/hooks/store/useCurrentUser';

import CSSModule from './ContactPage.module.scss';

const ContactPage: React.FC = () => {
  const navigate = useNavigate();
  const [currentParent] = useCurrentUser();

  const isShowLinkToWithdrawal =
    currentParent?.organization_memberships.length === 0;
  const goBack = () => navigate('/mypage/profile');

  return (
    <SingleCardTemplate title={pageTitles.contact}>
      <Helmet>
        <title>{pageTitles.contact}</title>
      </Helmet>
      <div className={CSSModule.ContactPage}>
        <Contact />
        {isShowLinkToWithdrawal && (
          <p className={CSSModule.ContactPage__Withdrawal}>
            <Link to="/withdrawal">{pageTitles.withdrawal}</Link>
          </p>
        )}
        <BackToPageButton
          onClick={goBack}
          className={CSSModule.ContactPage__BackToPageButton}
        >
          ＜戻る
        </BackToPageButton>
      </div>
    </SingleCardTemplate>
  );
};

export default ContactPage;
